import React from 'react';

import { DoctorProfileCard, PatientProfileCard } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import { FileBox, MCButton, Spinner } from 'src/components/basic';

import { getSelectLabel, lang, permissions, remCss, scssVariables, withRouter } from 'src/helpers';

import model from './model';

import moment from 'moment/moment';
import constants from 'src/constants';
import Buttons from './Buttons';
import AppointmentStatus from 'src/components/appointments/AppointmentStatus';

const apiStateId = 'updateStatus';

const { PAGES, ACTIONS } = permissions;

class Detail extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    this.init();
  }

  init = () => {
    let appointmentId = this.props.router.params.id;

    model.loadDetail(appointmentId, (appointment) => {
      if (!appointment) {
        this.navigate('/');
      }
    });
  };

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  render() {
    const { appointment, user } = model.getState();
    const doctor = appointment?.doctor || {};
    const patient = appointment?.patient || {};
    const media = appointment?.media || [];
    let { answers = [] } = appointment?.data || {};
    const createState = model.getApiState(apiStateId);
    answers = answers.filter((item) => !!item.answer);

    const params = { auth: model.state.user, appointment };

    return (
      <div className={'mc-container-content'}>
        <div className={'mc-container-content__header mc-flex-15'}>
          <div className={'mc-no-style-btn'} style={{ height: remCss(40) }} onClick={this.back}>
            <SVGIcon width={40} iconname={'back-icon'} />
          </div>
          <span className={'mc-grow'}>{lang.t('Appointment details')}</span>
        </div>
        {!appointment ? (
          <div>
            <Spinner />
          </div>
        ) : (
          <div className={'mc-container-content__body mc-book-doctor'}>
            <div className={'mc-container-content__body-content'}>
              <div className={'mc-tab-box'}>
                <div className={'mc-tab-content'}>
                  <div className={'mc-flex mc-grow'}>
                    <div className={'mc-container-content__body-left mc-flex-20-col'}>
                      {doctor.id === user.id ? (
                        <>
                          <PatientProfileCard patient={appointment.patient} />
                          <div className={'mc-flex-col mc-grow mc-bt mc-pt20'}>
                            <div className={'mc-label-416'}>{lang.t('Appointment Status')}</div>
                            <div className={'mc-flex'}>
                              <AppointmentStatus appointment={appointment} />
                            </div>
                          </div>
                        </>
                      ) : (
                        <DoctorProfileCard doctor={doctor} />
                      )}
                    </div>
                    <div className={'mc-container-content__body-center'}>
                      <div className={'mc-flex-25-col'}>
                        {createState.error && (
                          <p className='mc-error'>{createState.errorMessage}</p>
                        )}
                        <div className={'mc-flex-10'} style={{ marginRight: remCss(-20) }}>
                          <div className={'mc-value-622 mc-grow'}>
                            {lang.t('Appointment details')}
                          </div>
                          {ACTIONS.APPOINTMENTS_EDIT_BUTTON.checkActive(params) && (
                            <MCButton
                              {...ACTIONS.APPOINTMENTS_EDIT_BUTTON.attributes}
                              medium
                              type={'link'}
                              to={PAGES.APPOINTMENTS_EDIT_PAGE.match(appointment.id)}
                            />
                          )}
                        </div>
                        <div className={'mc-flex'}>
                          <div className={'mc-grow mc-flex-10-col'}>
                            <div className={'mc-label-418'}>{lang.t('Date')}</div>
                            <MCButton
                              primary
                              radius
                              medium
                              light
                              className={'mc-fit-content'}
                              label={
                                appointment.data?.startDate
                                  ? moment(appointment.data.startDate).format('DD MMMM, YYYY')
                                  : ''
                              }
                            />
                          </div>
                          <div className={'mc-grow mc-flex-10-col'}>
                            <div className={'mc-label-418'}>{lang.t('Time')}</div>
                            <MCButton
                              primary
                              radius
                              medium
                              light
                              className={'mc-fit-content'}
                              label={
                                appointment.data?.startDate
                                  ? moment(appointment.data.startDate).format('hh:mm a')
                                  : ''
                              }
                            />
                          </div>
                          <div className={'mc-grow mc-flex-10-col'}>
                            <div className={'mc-label-418'}>{lang.t('Type')}</div>
                            <MCButton
                              primary
                              radius
                              medium
                              light
                              className={'mc-fit-content'}
                              label={getSelectLabel(
                                constants.general.appointment_types,
                                appointment.data.appointmentType
                              )}
                            />
                          </div>
                        </div>
                        {!!appointment.data.hospital && (
                          <div className={'mc-flex-10-col'}>
                            <div className={'mc-label-418'}>{lang.t('Location')}</div>
                            <div className={'mc-flex'}>
                              <SVGIcon
                                iconname={BASE_ICONS.LOCATION}
                                width={50}
                                fill={scssVariables['colors-mc-primary']}
                                radius
                                light
                              />
                              <div className={'mc-grow mc-flex-col'}>
                                {(appointment?.data?.hospital || '').split('\n').map((txt, i) => (
                                  <div className={i === 0 ? ' mc-note-2' : ''} key={i}>
                                    {i === 0 ? txt.split('_')[0] : txt}
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}
                        {appointment.data.disease && (
                          <div className={'mc-flex-15-col'}>
                            <div className={'mc-value-622'}>{lang.t('Disease')}</div>
                            <div className={'mc-label-418'}>{appointment.data.disease}</div>
                          </div>
                        )}
                        {appointment.data.symptoms && (
                          <div className={'mc-flex-15-col'}>
                            <div className={'mc-value-622'}>{lang.t('Symptoms')}</div>
                            <pre className={'mc-label-418'}>{appointment.data.symptoms}</pre>
                          </div>
                        )}
                        {answers.length > 0 && (
                          <>
                            <div className={'mc-value-622'}>{lang.t('Appointment Questions')}</div>
                            <div className={'mc-flex-15-col'}>
                              {answers.map((item, index) => {
                                if (!item.answer) return null;
                                return (
                                  <div key={index} className={'mc-flex-15-col'}>
                                    <div className={'mc-value-520'}>{item.question}</div>
                                    <pre className={'mc-label-418'}>{item.answer}</pre>
                                  </div>
                                );
                              })}
                            </div>
                          </>
                        )}
                        {media?.length > 0 && (
                          <>
                            <div className={'mc-value-622'}>{lang.t('Photos / Files')}</div>
                            <div className={'mc-flex mc-wrap'}>
                              {media.map((file, index) => (
                                <FileBox
                                  list={media}
                                  key={'mc-media-' + index}
                                  file={file}
                                  onClose={null}
                                  styles={{ width: remCss(150), height: remCss(150) }}
                                  onlyPreview={true}
                                  showFileName={true}
                                />
                              ))}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={'mc-container-content__body-footer mc-flex'}>
              <div className={'mc-grow'}></div>
              <Buttons
                appointment={appointment}
                patient={patient}
                user={user}
                doctor={doctor}
                params={params}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(Detail);
